import React from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, Link } from "react-router-dom";
import Mentee from "../../assets/new images/student 1.png";
import Mentor from "../../assets/new images/mentor 1.png";
import Logo from "../../assets/new images/logo.png";
import Seo from "../../components/Seo";
import SEO from "../../seo/pages.json";

// Clickable card WITHOUT caption inside
const Card = ({ img, onClick, ariaLabel }) => (
  <button
    aria-label={ariaLabel}
    onClick={onClick}
    className="group w-full max-w-[660px] rounded-2xl border border-[#F5CDBB] bg-white/90 shadow-[0_10px_40px_-15px_rgba(17,24,39,0.15)] p-5 text-left transition hover:shadow-xl focus:outline-none focus-visible:ring-4 focus-visible:ring-[#EE5F2B]/30"
  >
    <div className="aspect-[16/10] w-full overflow-hidden rounded-xl flex justify-center items-center">
      <img src={img} alt="" className="h-[100%] w-[100%] object-contain" />
    </div>
  </button>
);

export default function Roles(Login) {
  const { t } = useTranslation();
  const navigate = useNavigate();


  const redirect = Login.Login || "signup"; // "login" | "signup"
  const routes = {
    login: {
      mentee: "/login/mentee-login",
      mentor: "/login/mentor-login",
    },
    signup: {
      mentee: "../login/mentee-sign-up",
      mentor: "../login/mentor-sign-up",
    },
  };

  const go = (role) => {
    const path = routes[redirect]?.[role];
    if (path) navigate(path);
  };

  const isLogin = redirect === "login";

  return (
    <main className="relative min-h-screen w-full grid place-items-center overflow-hidden">
      <Seo
        {...SEO[isLogin ? "/login" : "/signup"]}
        path={isLogin ? "/login" : "/signup"}
      />
      {/* soft background */}
      <div className="absolute inset-0 bg-gradient-to-br from-[#FFF4EE] via-[#FFF8F4] to-white" />
      <div className="pointer-events-none absolute -left-24 -top-24 w-[38rem] h-[38rem] rounded-full bg-[#FFB899]/25 blur-3xl" />
      <div className="pointer-events-none absolute -right-28 bottom-0 w-[42rem] h-[42rem] rounded-full bg-[#FFD9C9]/30 blur-3xl" />

      <div className="relative w-11/12 md:w-4/5 lg:w-1/2 mx-auto max-w-6xl px-5 py-10">
        {/* Logo */}
        <div className="w-full flex justify-center mb-8">
          <div className="w-16 h-16 grid place-items-center rounded-2xl">
            <img src={Logo} className="h-20 w-20" alt="Cabil logo" />
          </div>
        </div>

        {/* Heading */}
        <div className="text-center mb-8">
          <h1 className="text-3xl md:text-[32px] font-semibold text-[#2A3A54]">
            {t("roles.heroTitle")}
          </h1>
          <p className="mt-2 text-sm text-[#6B7280]">
            {t("roles.heroSubtitle")}
          </p>
        </div>

        {/* Cards + captions below */}
        <div className="max-w-4xl w-full grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-10 place-items-center">
          {/* Mentee */}
          <div className="w-full max-w-[660px] text-center">
            <Card img={Mentee} ariaLabel={t("roles.chooseMentee")} onClick={() => go("mentee")} />
            <p className="mt-3 text-lg font-semibold text-[#EE5F2B]">{t("roles.mentee")}</p>
          </div>

          {/* Mentor */}
          <div className="w-full max-w-[520px] text-center">
            <Card img={Mentor} ariaLabel={t("roles.chooseMentor")} onClick={() => go("mentor")} />
            <p className="mt-3 text-lg font-semibold text-[#EE5F2B]">{t("roles.mentor")}</p>
          </div>
        </div>

        {/* foot links */}
        <div className="text-center mt-8">
          <p className="text-sm text-gray-600">
            {t("roles.kidsPrompt")}{" "}
            <Link to="/kids/signup" className="text-[#EE5F2B] font-semibold hover:underline">
              {t("roles.kidsCta")}
            </Link>
          </p>
          <p className="text-sm text-gray-600 mt-3">
            {t("roles.institutionText")}
          </p>
        </div>
      </div>
    </main>
  );
}
